export const mapReportTypesDict = dict => {
    const critical = dict.critical ? Object.keys(dict.critical) : []
    const warning = dict.warning ? Object.keys(dict.warning) : []
    // const infested = Object.keys(dict.infested)
    const info = dict.info ? Object.keys(dict.info) : []
    const inactive = dict.inactive ? Object.keys(dict.inactive) : []
    const down = dict.all.down ? [dict.all.down] : []
    const catchConst = dict.all.catch ? [dict.all.catch] : []

    return {
        critical,
        warning,
        // infested,
        info,
        inactive,
        down,
        catch: catchConst
    }
}
